import { Application } from "@hotwired/stimulus"
import NavbarController from "./navbar_controller"

const application = Application.start()


// Add Turbo error handling
document.addEventListener('turbo:load', () => {
  console.log('Page loaded via Turbo')
})

document.addEventListener('turbo:visit', () => {
  console.log('Initiated Turbo visit')
})

document.addEventListener('turbo:before-cache', () => {
  // Clean up any necessary state before caching
})

document.addEventListener('turbo:before-render', () => {
  // Prepare for new page render
})

document.addEventListener('turbo:render', () => {
  console.log('New page rendered')
})

document.addEventListener('turbo:before-fetch-response', (event) => {
  if (!event.detail.fetchResponse.response.ok) {
    event.preventDefault()
    window.location.reload()
  }
})


// Configure Stimulus development experience
application.debug = true
window.Stimulus = application

application.register("navbar", NavbarController)

export { application }
